import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=00c71eb6&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"
import style0 from "./Modules.vue?vue&type=style&index=0&id=00c71eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c71eb6",
  null
  
)

export default component.exports